export default __webpack_public_path__ + "static/media/sirolaser.cf4a77a2.png";